import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const postLanguage = languageData => {
  return dispatch => {
    dispatch({ type: "POST_LANGUAGE_LOADING" });
    api
      .languagePost(languageData)
      .then(resp => {
        if (languageData.languageId) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "AddLanguageErrorAlertTitle",
          "Virhe kielitaidon tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_LANGUAGE_SUCCEEDED",
  payload: { language: data },
});

const postEditSucceeded = data => ({
  type: "POST_LANGUAGE_EDIT_SUCCEEDED",
  payload: { language: data },
});

const operationFail = () => ({
  type: "POST_LANGUAGE_FAIL"
});